import { PhotoData } from "../../photo/interfaces/dto";

export function generatePhotoData(
	photoId: number,
	gridPhotoWrapper: HTMLElement,
	gridPhoto: HTMLImageElement,
): PhotoData {
	const { findHtmlEl } = pm.utils.dom;

	const gridItem = gridPhotoWrapper.parentElement;

	const authorDataEl = findHtmlEl(gridPhotoWrapper, ".gallery-author");

	const rawCaptionOriginEl = findHtmlEl(gridPhotoWrapper, ".raw-photo-caption");

	const originLocationEl = findHtmlEl(gridPhotoWrapper, ".gallery-location");

	const galleryMetaDataSelector = ".gallery-metadata";

	const originApertureEl = findHtmlEl(
		gridPhotoWrapper,
		galleryMetaDataSelector + " .aperture",
	);

	const originShutterSpeedEl = findHtmlEl(
		gridPhotoWrapper,
		galleryMetaDataSelector + " .shutter-speed",
	);

	const originIsoEl = findHtmlEl(
		gridPhotoWrapper,
		galleryMetaDataSelector + " .iso",
	);

	let categoryIdsAttrVal = gridPhotoWrapper.dataset.categoryIds;
	categoryIdsAttrVal = categoryIdsAttrVal ? categoryIdsAttrVal.trim() : "";

	let categoryIds: Array<number> = [];

	if (categoryIdsAttrVal) {
		const splits = categoryIdsAttrVal.split(",");

		if (splits.length) {
			// Loop through splits and push the value to categoryIds.
			for (let i = 0; i < splits.length; i++) {
				const categoryId = parseInt(splits[i], 10);

				if (categoryId) {
					categoryIds.push(categoryId);
				}
			}
		}
	}

	const photoWidthRawVal = gridPhoto.getAttribute("width");
	const photoHeightRawVal = gridPhoto.getAttribute("height");

	let videoUrl = gridPhotoWrapper.dataset.videoUrl ?? "";
	videoUrl = videoUrl ? videoUrl + "?autoplay=1&rel=0" : "";

	const isVideo = videoUrl ? true : false;

	return {
		id: photoId,
		postName: "",
		date: gridPhotoWrapper.dataset.publishedDate ?? "",
		description: rawCaptionOriginEl ? rawCaptionOriginEl.innerHTML : "",
		attachmentUrl: gridPhotoWrapper.dataset.attachmentUrl ?? "",
		authorId:
			authorDataEl && authorDataEl.dataset.authorId
				? parseInt(authorDataEl.dataset.authorId, 10)
				: 0,
		authorNicename:
			authorDataEl && authorDataEl.dataset.authorNicename
				? authorDataEl.dataset.authorNicename
				: "",
		authorDisplayName:
			authorDataEl && authorDataEl.dataset.authorDisplayName
				? authorDataEl.dataset.authorDisplayName
				: "",
		authorProfileUrl:
			authorDataEl && authorDataEl.dataset.authorProfileUrl
				? authorDataEl.dataset.authorProfileUrl
				: "",
		authorAvatarUrl:
			authorDataEl && authorDataEl.dataset.authorAvatarUrl
				? authorDataEl.dataset.authorAvatarUrl
				: "",
		authorMembershipType:
			authorDataEl && authorDataEl.dataset.authorMembershipType
				? authorDataEl.dataset.authorMembershipType
				: "",
		potd: gridPhoto.classList.contains("assigned-to-potd"),
		potm: gridPhoto.classList.contains("is-potm"),
		featured: gridPhoto.classList.contains("is-featured"),
		address: originLocationEl && !isVideo ? originLocationEl.innerHTML : "",
		album: "",
		imageTitle: gridPhoto.alt,
		aperture: originApertureEl ? originApertureEl.innerHTML : "",
		shutterSpeed: originShutterSpeedEl ? originShutterSpeedEl.innerHTML : "",
		iso: originIsoEl ? originIsoEl.innerHTML : "",
		camera: gridPhotoWrapper.dataset.camera ?? "",
		cameraSlug: gridPhotoWrapper.dataset.cameraSlug ?? "",
		cameraUrl: gridPhotoWrapper.dataset.cameraUrl ?? "",
		cameraAlias: gridPhotoWrapper.dataset.cameraAlias ?? "",
		focalLength: gridPhotoWrapper.dataset.focalLength ?? "",
		editableCamera: !!gridPhotoWrapper.dataset.editableCamera,
		editableFocalLength: !!gridPhotoWrapper.dataset.editableFocalLength,
		url: gridPhoto.src,
		width: photoWidthRawVal ? parseInt(photoWidthRawVal, 10) : 0,
		height: photoHeightRawVal ? parseInt(photoHeightRawVal, 10) : 0,
		urlLarge: gridPhotoWrapper.dataset.largeUrl ?? "",
		totalLikes: gridPhotoWrapper.dataset.totalLikes
			? parseInt(gridPhotoWrapper.dataset.totalLikes, 10)
			: 0,
		totalComments: 0,
		isLiked: gridPhoto.classList.contains("is-liked"),
		categories: categoryIds,
		adId: gridItem?.dataset.spcId ? parseInt(gridItem.dataset.spcId, 10) : 0,
		needsFeedback: !!gridPhotoWrapper.dataset.needsFeedback,
		videoUrl: videoUrl,
	};
}
